import React, { useEffect, useState } from "react";
import { Paper, Drawer, Box, Typography } from "@mui/material";
import { filteredListItems } from "../sharedComponents/PanelList";
import { DocumentAutocomplete } from "./navigationComponents/DocumentAutocomplete";
import { NavigationButtons } from "./navigationComponents/NavigationButtons";

export const NavigationListMD = ({
  menuOpen,
  handleItemClick,
  handleMenuToggle,
  documentID,
  setDocumentID,
  setNameDocument,
  selectedItem,
  rol,
  documents,
  documentsLoading,
}) => {
  const [selectedButton, setSelectedButton] = useState(selectedItem);
  const ListItems = filteredListItems(rol);

  const handleButtonClick = (id) => {
    setSelectedButton(id);
    handleItemClick(id);
    handleMenuToggle();
  };

  useEffect(() => {
    if (!documentID && selectedButton !== 0 && selectedButton !== 8 && selectedButton !== 12 && selectedButton !== 13) {
      setSelectedButton(0);
      handleItemClick(0);
    }
  }, [documentID, selectedButton, handleItemClick]);

  const ListComponent = ListItems.map((item) => (
    <NavigationButtons
      key={item.id}
      item={item}
      selectedButton={selectedButton}
      handleButtonClick={handleButtonClick}
      documentID={documentID}
    />
  ));

  return (
    <>
      <Drawer
        anchor="left"
        open={menuOpen}
        onClose={handleMenuToggle}
        variant="temporary"
        ModalProps={{ keepMounted: true }}
      >
        <Paper
          elevation={0}
          style={{
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            padding: "20px",
            boxSizing: "border-box",
            width: 250,
          }}
        >
          <div
            style={{
              marginBottom: "40px",
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" component="div" fontWeight="bold" color="primary">
                EDITOR{" "}
                <Typography component="span" sx={{ fontSize: "0.7em", color: "error.main", verticalAlign: "middle" }}>
                  v.26
                </Typography>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                SIGEDI
              </Typography>
            </Box>
          </div>
          <div
            style={{
              marginBottom: "20px",
            }}
          >
            <DocumentAutocomplete
              documentID={documentID}
              setDocumentID={setDocumentID}
              setNameDocument={setNameDocument}
              documents={documents}
              loading={documentsLoading}
            />
          </div>
          <div
            style={{
              flexGrow: 1,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {ListComponent}
          </div>
          <div
            style={{
              marginTop: "auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
          </div>
        </Paper>
      </Drawer>
    </>
  );
};
